export default __webpack_public_path__ + "4c6293df2574528c48e3634c728cf989.png";